import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import {
  AE_LABEL,
  AE_LABEL_COMPACT,
  AE_MUTED,
  AE_SECTION_TITLE,
  AE_SECTION_TITLE_COMPACT,
  AE_SELECT,
  AE_SELECT_COMPACT,
} from '@/components/assessment-engine/layout/aeTheme';
import type { AeAdminCompletionDigestFrequency } from '@/types/assessmentEngine';

const FREQUENCIES: AeAdminCompletionDigestFrequency[] = ['every', 'daily', 'weekly', 'monthly'];

interface CampaignAdminDigestFieldsProps {
  value: AeAdminCompletionDigestFrequency;
  onChange: (next: AeAdminCompletionDigestFrequency) => void;
  disabled?: boolean;
  compact?: boolean;
}

/** Campaign-wide preference for how admins are notified of completions. */
export const CampaignAdminDigestFields: React.FC<CampaignAdminDigestFieldsProps> = ({
  value,
  onChange,
  disabled = false,
  compact = false,
}) => {
  const { t } = useLanguage();
  const titleClass = compact ? AE_SECTION_TITLE_COMPACT : AE_SECTION_TITLE;
  const labelClass = compact ? AE_LABEL_COMPACT : AE_LABEL;
  const selectClass = compact ? AE_SELECT_COMPACT : AE_SELECT;

  return (
    <section className={compact ? 'space-y-2' : 'space-y-3'}>
      <div>
        <h2 className={titleClass}>{t('assessmentEngine.admins.digestTitle')}</h2>
        <p className={`${AE_MUTED} ${compact ? 'text-xs mt-0.5' : 'text-sm mt-1'}`}>
          {t('assessmentEngine.admins.digestHint')}
        </p>
      </div>
      <div className={compact ? 'max-w-xs' : undefined}>
        <label className={labelClass} htmlFor="ae-admin-digest-frequency">
          {t('assessmentEngine.admins.digestFrequency')}
        </label>
        <select
          id="ae-admin-digest-frequency"
          className={selectClass}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value as AeAdminCompletionDigestFrequency)}
        >
          {FREQUENCIES.map((freq) => (
            <option key={freq} value={freq}>
              {t(`assessmentEngine.admins.digest.${freq}`)}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
};
